<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <el-row>
                    <el-col>
                        <div class="spreadsheet-header-title">
                            {{ title }}
                        </div>
                        <div class="spreadsheet-header-filter-info">
                            <span class="spreadsheet-header-filter-info_black">
                                Поиск по:
                            </span>
                            <span class="spreadsheet-header-filter-info_gray">
                                {{ query }}
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spreadsheet-header-filter-info_black">
                            Всего найдено:
                        </span>
                        <span class="spreadsheet-header-filter-info_gray">
                            {{ totalItems }}
                        </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="closeSearch()">
                    Закрыть
                </el-button>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalItems"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';

library.add(faEye);

export default {
    name: 'ContactsGrid',
    props: {
        query: {
            type: [String],
            default: null
        }
    },
    data() {
        return {
            title: 'Контакты. Результат поиска',
            totalItems: 0,
            fieldsNames: {
                name: 'имя контакта',
                phone: 'телефон',
                email: 'e-mail',
                birthday: 'день рождения',
                company_id: 'компания'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            pickerOptions,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            companyOptions: []
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    computed: {
        contacts() {
            return this.$store.state.contacts.contacts;
        },
        pagesInfo() {
            return this.$store.state.contacts.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        companies() {
            return this.$store.state.references.companies;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.name),
                field: 'name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.phone),
                field: 'contact_phones',
                cellRenderer: ({ data }) => data.contact_phones && data.contact_phones.length ? data.contact_phones.map(item => item.phone).join(', ') : ''
            },
            {
                headerName: this.fieldsNames.email,
                field: 'email'
            },
            {
                headerName: this.capitalize(this.fieldsNames.birthday),
                field: 'birthday',
                cellRenderer: (params) => {
                    return params.data.birthday_date;
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.company_id),
                field: 'company_id',
                cellRenderer: (params) => {
                    if (params.data.company_id) {
                        return params.data.company_name;
                    }
                    return '';
                }
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: (params) => {
                    return this.getLinkElement(params.data.id, '', { name: 'contact-card', params: { id: params.data.id } }, 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.getDataFromServer();
                this.setSettings();
            }).catch(() => {
        });
    },
    methods: {
        searchCompany(query) {
            if (query !== '') {
                this.companyOptions = this.companies.filter(
                    item => item.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
            } else {
                this.companyOptions = JSON.parse(JSON.stringify(this.companies));
            }
        },
        setSettings() {
            if (this.setting.contacts) {
                this.gridOptions.columnApi.setColumnState(this.setting.contacts.table);
                this.gridOptions.api.setSortModel(this.setting.contacts.sort);
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
                element.innerText = name;
            }
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        onSelectionChanged(e) {
            this.$router.push({ name: 'contact-card', params: { id: '' + e.node.data.id } });
        },
        getDataFromServer() {
            const requestParams = {
                type: 'contact',
                query: this.query,
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage
            };
            this.loading = true;
            this.$store.dispatch('search/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(response.data.data.contacts);
                    this.totalItems = response.data.data.contact.info.value;
                    this.loading = false;
                }).catch(
                error => {
                    console.log(error);
                });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        closeSearch() {
            this.$router.go(-1);
        },
        capitalize: capitalize
    }
};
</script>
